module.exports = __webpack_public_path__ + "img/Feature.1bce1cf2.jpg";